import { Content } from 'rsuite';
import styles from './ComparingChannelHeader.module.scss';

export const ComparingChannelHeader = () => (
  <Content className={styles['comparing-channel-content']}>
    <h5 className={styles.title}>Comparação entre canais</h5>
    <p className={styles.description}>
      Na comparação entre canais, o preço do canal físico serve como referência e corresponde a 100% do preço base. Os demais canais são comparados a partir
      desse valor.
    </p>
  </Content>
);
